import { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 0.1; }
`;

const fadeOut = keyframes`
  from { opacity: 0.1; }
  to { opacity: 0; }
`;

const Circle = styled.div`
  position: fixed;
  border-radius: 50%;
  filter: blur(80px);
  pointer-events: none;
  z-index: -1;
  opacity: 0;
  animation: ${fadeIn} 1s ease-in forwards,
             ${fadeOut} 2s ease-out 4s forwards;
`;

const BackgroundCircles = () => {
  const [circles, setCircles] = useState([]);

  const createCircle = () => {
    const colors = ['#FF0000', '#FFD700', '#0000FF'];
    const color = colors[Math.floor(Math.random() * colors.length)];
    const size = Math.random() * 300 + 400;
    const x = Math.random() * window.innerWidth;
    const y = Math.random() * window.innerHeight;

    return {
      id: Date.now(),
      color,
      size,
      x,
      y
    };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCircles(prevCircles => {
        // Remove circles that have been visible for more than 6 seconds
        const currentTime = Date.now();
        const filteredCircles = prevCircles.filter(
          circle => currentTime - circle.id < 6000
        );
        
        // Add new circle
        const newCircle = createCircle();
        return [...filteredCircles, newCircle];
      });
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {circles.map(circle => (
        <Circle
          key={circle.id}
          style={{
            backgroundColor: circle.color,
            width: `${circle.size}px`,
            height: `${circle.size}px`,
            left: `${circle.x}px`,
            top: `${circle.y}px`
          }}
        />
      ))}
    </>
  );
};

export default BackgroundCircles;
